import "./banner/Banner.css";
import Banner from "./banner/Banner";
import KeyFeatureComponent from "./KeyFeatureComponent/KeyFeatureComponent";
import Our_Services from "./Our_Services/Our_Services";
import Insurance from "./Insurance/Insurance";
import Calculate_Personal_Loan_Emi from "../Common_Component/Calculate_Personal_Loan_Emi/Calculate_Personal_Loan_Emi";
import Our_Partners from "./Our_Partners/Our_Partners";
import Advantage_of_Loan from "./Advantage_of_Loan/Advantage_of_Loan";
import Testimonials from "./testimonials/Testimonials";

function Home() {
  return (
    <>
      <div id="Banner">
        <Banner />
      </div>

      <div id="key_feature">
        <KeyFeatureComponent />
      </div>

      <div id="our_service">
        <Our_Services />
      </div>

      <div id="Insurance">
        <Insurance />
      </div>

      <div id="calculate_loan">
        <Calculate_Personal_Loan_Emi heading="Calculate Your Personal Loan EMI" />
      </div>

      <Our_Partners />
      <Advantage_of_Loan />
      <Testimonials />
    </>
  );
}

export default Home;
